// Components
import { CustomModal } from 'components/molecules/Modal/Modal'
import { Typography } from '@mui/material'

// Utils
import { getReadableAssetType } from 'lib/utils/getAssetTypeLabel'

// Context
import { useAssetType } from 'lib/context/AssetTypeContext/AssetTypeContext'
import { useScannerActionModalsStore } from 'store/scannerActionModals/scannerActionModals'

// Styles
import styles from './AssetMissMatchModal.module.scss'

const AssetMissMatchModal = () => {
  const { assetMissMatchModal } = useScannerActionModalsStore()
  const { handleChangeAssetType } = useAssetType()

  const { isOpen, productType, assetType, onConfirm, onCancel } =
    assetMissMatchModal
  if (!isOpen) return null

  const handleOnSubmit = () => {
    if (!productType) return

    handleChangeAssetType(productType)
    onConfirm?.()
  }

  const handleOnClose = () => {
    onCancel?.()
  }

  return (
    <CustomModal
      open={isOpen}
      onCloseTakeSecondaryButtonAction={true}
      icon={<></>}
      header="Product Type Mismatch"
      primaryButtonText={`Change to ${getReadableAssetType(productType)}`}
      secondaryButtonText={`Keep as ${getReadableAssetType(assetType)}`}
      handleOnSubmit={handleOnSubmit}
      secondaryButtonAction={handleOnClose}
      isLoadingState={false}
      className={styles.assetMismatchModal}
    >
      <div className={styles.textContainer}>
        <Typography className={styles.text}>
          MedGEO AI has identified this product as{' '}
          <strong>{getReadableAssetType(productType)}</strong>.
        </Typography>
      </div>
    </CustomModal>
  )
}

export default AssetMissMatchModal
